"use client";

import { useContext, createContext } from "react";

import { SettingsContextProps } from "../types";

// ----------------------------------------------------------------------
// ----------------------------------------------------------------------
// ----------------------------------------------------------------------
// IMPORTANTE: These types are only copied from the original file to encapsulation the widget
// ----------------------------------------------------------------------
// ----------------------------------------------------------------------
// ----------------------------------------------------------------------

export interface AssistantDoc {
  // relation to user
  ownerUid: string;
  // same as doc id
  assistantId: string;
  // firestore.Timestamp
  createdAt: any;
  openai?: {
    assistantId: string;
    name?: string;
    apiKeyId: string;
    description?: string;
    model?: string;
    instructions?: string;
    files?: {
      id: string;
      name: string;
    }[];
    capabilities?: string[];
    functionSchemas?: {
      id: string;
      schema: string;
      apiKeyHeader?: string | "Bearer" | "Basic";
    }[];
  };
}

interface WidgetUiSettings {
  name: string;
  description: string;
  chatPersistence: 'never' | 'tabClosed';
  position: 'left' | 'right';
  sideSpacing: number;
  bottomSpacing: number;
  poweredBy?: boolean;
  mainColor: string;
  laucherBgColor: string;
  noLauncherBg: boolean;
  direction: 'rtl' | 'ltr';
  launcherIcon: File | null;
  assistantAvatar: File | null;
  mode: 'light' | 'dark';
  startMessage: string;
  inputPlaceholder: string;
  greetingUser: string;

  launcherIconSizeDesktop?: number;
  launcherIconSizeMobile?: number;

  notifications: {
    email?: string;
    emails?: string[];
    phones?: string[];
    time: number;
    whatsappNumbers?: string[];
  };
  unsubscribedFromNotifications: {
    emails?: string[];
    phones?: string[];
    whatsappNumbers?: string[];
  };

  whatsappNumber?: string;

  assistant: AssistantDoc | null | any;

  welcomeMessage: string;

  redirectToWhatsapp?: boolean;
  useTextToVoice?: string;
  acceptConsent?: 'required' | 'optional' | 'disabled';
  prefillMessageToStartAssistant?: boolean;
  staticForm?: number;
  smsFeedbackMessage?: string;
  smsFeedbackMessageTime?: number;
  isCreateTechyCustomer?: boolean;
  enableSmsFeedback?: boolean;

  welcomeMessageColor?: string;

  widgetId?: string;
  ownerUid?: string;
  isAssistantAvatar?: boolean;
  twilioPhoneNumber?: {
    smsUrl?: string;
    serviceSid?: string;
    ownerUid?: string;
    phoneNumber?: string;
    sid?: string;
    friendlyName?: string;
    dateCreated?: string;
    dateUpdated?: string;
    capabilities?: any;
    disabledAssistant?: boolean;
  };

  directSmsPhoneNumber?: string;
}

// ----------------------------------------------------------------------

export interface WidgetSettings extends WidgetUiSettings {
  plan: string | null;
  errorSelectingAssistant: boolean;
  apiKeyId?: string;
  poweredBy?: boolean;
}

export const WidgetSettingsContext = createContext(
  {} as SettingsContextProps &
    WidgetSettings & {
      setSettings: <K extends keyof WidgetSettings>(field: K, value: WidgetSettings[K]) => void;
      resetDefaultUISettings: () => void;
    }
);

export const useWidgetSettingsContext = () => {
  const context = useContext(WidgetSettingsContext);

  if (!context) throw new Error("useSettingsContext must be use inside SettingsProvider");

  return context;
};
